import { render, staticRenderFns } from "./NewsfeedPost.vue?vue&type=template&id=12c891f2&scoped=true&"
import script from "./NewsfeedPost.vue?vue&type=script&lang=js&"
export * from "./NewsfeedPost.vue?vue&type=script&lang=js&"
import style0 from "./NewsfeedPost.vue?vue&type=style&index=0&id=12c891f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c891f2",
  null
  
)

export default component.exports